import { render, staticRenderFns } from "./AssignFollowersDialog.vue?vue&type=template&id=a175295a&scoped=true"
import script from "./AssignFollowersDialog.vue?vue&type=script&lang=js"
export * from "./AssignFollowersDialog.vue?vue&type=script&lang=js"
import style0 from "./AssignFollowersDialog.vue?vue&type=style&index=0&id=a175295a&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a175295a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a175295a')) {
      api.createRecord('a175295a', component.options)
    } else {
      api.reload('a175295a', component.options)
    }
    module.hot.accept("./AssignFollowersDialog.vue?vue&type=template&id=a175295a&scoped=true", function () {
      api.rerender('a175295a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bill/components/AssignFollowersDialog.vue"
export default component.exports